import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Table, Tag, Button } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import defaults from '../../utils/defaults';
import ProgressBars from '../../components/MXCard/ProgressBars';
import EmptyStateMaintenance from '../../assets/emptyState/empty-state-maintenance.svg';
import styles from './WorkpackProfile.module.less';

class OopTable extends PureComponent {
  static propTypes = {
    dataSource: PropTypes.array.isRequired,
    userSettings: PropTypes.object,
    extraColumns: PropTypes.array,
    globalFilter: PropTypes.string,
    selectedAircraft: PropTypes.object,
    intl: PropTypes.object.isRequired,
  };

  static defaultProps = {
    extraColumns: [],
    userSettings: defaults.defaultDateFormat,
    globalFilter: '',
    selectedAircraft: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      expandedDescRowId: '',
    };
  }

  renderOopColumns() {
    const {
      intl: { formatMessage },
      selectedAircraft,
      userSettings: { dateFormat },
      globalFilter: globalFilterProp,
    } = this.props;
    const aircraftThreshold = selectedAircraft ? selectedAircraft.mx_thresholds : {};
    const aircraftAPUEnabled = selectedAircraft ? selectedAircraft.apu_installed : false;
    const globalFilter = globalFilterProp.toLowerCase();
    const itemRefColumn = {
      title: formatMessage({ id: 'title.itemRef' }),
      dataIndex: 'ata_number',
      rowKey: 'ata_number',
      width: 350,
      sorter: (a, b) => a.ata_number - b.ata_number,
      render: (text, row) => {
        const area =
          row.mx_type === 'apu_oop'
            ? row.mx_type
                .replace(/_/g, ' ')
                .replace(' oop', '')
                .toUpperCase()
            : (row.mx_type.charAt(0).toUpperCase() + row.mx_type.slice(1)).replace(/_/g, ' ').replace(' oop', '');
        const chapter = row.ata_number ? (
          <div className={styles.oopDetailsTitle}>
            {formatMessage({ id: 'title.chapter' })}: <span className={styles.divFontWeight}>{row.ata_number}</span>
          </div>
        ) : null;
        const item = row.name ? (
          <div className={styles.oopDetailsTitle}>
            {formatMessage({ id: 'title.item' })}: <span className={styles.divFontWeight}>{row.name}</span>
          </div>
        ) : null;
        const areaDiv = area ? (
          <div className={styles.oopDetailsTitle}>
            {formatMessage({ id: 'title.area' })}: <span className={styles.divFontWeight}>{area}</span>
          </div>
        ) : null;
        const { expandedDescRowId } = this.state;
        let descriptionMarkup = null;
        if (row.repeat_remarks) {
          if (expandedDescRowId === row.id) {
            descriptionMarkup = row.repeat_remarks;
          } else {
            descriptionMarkup = row.repeat_remarks.substring(0, 200);
          }
        }
        const showMoreButton = row.repeat_remarks && row.repeat_remarks.length > 200 && (
          <Button
            onClick={() => {
              if (expandedDescRowId === row.id) {
                this.setState({ expandedDescRowId: null });
              } else {
                this.setState({ expandedDescRowId: row.id });
              }
            }}
            className={styles.seeMoreDescription}
            size="small"
          >
            {expandedDescRowId === row.id
              ? formatMessage({ id: 'form.button.lessDetails' })
              : formatMessage({ id: 'form.button.moreDetails' })}
          </Button>
        );
        const notes = (
          <div className={styles.oopDetailsTitle}>
            {formatMessage({ id: 'title.notes' })}:
            <span className={styles.divFontWeight}>
              &nbsp;
              {descriptionMarkup}
              {showMoreButton}
            </span>
          </div>
        );
        const taskRef = row.reference ? (
          <Tag color="blue" className={styles.taskRefTag}>
            {row.reference}
          </Tag>
        ) : null;
        return (
          <div>
            {areaDiv}
            {chapter}
            {item}
            {notes}
            {taskRef}
          </div>
        );
      },
      filteredValue: [globalFilter],
      onFilter: (value, record) => {
        let outReturn = false;
        if (record.ata_number && !outReturn) {
          outReturn = record.ata_number
            .toString()
            .toLowerCase()
            .includes(globalFilter.toLowerCase());
        }
        if (record.name && !outReturn) {
          outReturn = record.name.toLowerCase().includes(globalFilter.toLowerCase());
        }
        if (record.reference && !outReturn) {
          outReturn = record.reference.toLowerCase().includes(globalFilter.toLowerCase());
        }
        if (record.repeat_remarks && !outReturn) {
          outReturn = record.repeat_remarks.toLowerCase().includes(globalFilter.toLowerCase());
        }
        if (record.mx_type && !outReturn) {
          outReturn = record.mx_type.toLowerCase().includes(globalFilter.toLowerCase());
        }
        if (!outReturn) {
          outReturn = globalFilter === '';
        }
        return outReturn;
      },
    };
    const flightHrsColumn = {
      title: formatMessage({ id: 'title.flightHrs' }),
      dataIndex: 'flight_seconds_repeat',
      rowKey: 'flight_seconds_repeat',
      width: 150,
      render: (text, row) => {
        if (row.flight_seconds_repeat || row.flight_seconds_due) {
          return (
            <div className={styles.oopDetails}>
              {row.flight_seconds_repeat ? (
                <p>
                  {formatMessage({ id: 'title.interval' })}:
                  <span className={styles.columnSpan}>
                    {row.flight_seconds_repeat / 3600} {formatMessage({ id: 'period.hrs' })}
                    {row.flight_seconds_threshold && row.flight_seconds_threshold >= row.flight_seconds_due ? (
                      <span className={styles.secondarySpan}>
                        {' '}
                        ({formatMessage({ id: 'text.thresholdShort' })} {row.flight_seconds_threshold / 3600}{' '}
                        {formatMessage({ id: 'period.hrs' })})
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                </p>
              ) : (
                ''
              )}
              {row.flight_seconds_due ? (
                <p>
                  {formatMessage({ id: 'text.nextDue' })}:
                  <span className={styles.columnSpan}>
                    {row.flight_seconds_due / 3600} {formatMessage({ id: 'period.hrs' })}
                    {row.flight_seconds_tolerance ? (
                      <span className={styles.secondarySpan}>
                        {' '}
                        (+/- {Math.abs(row.flight_seconds_tolerance / 3600)} {formatMessage({ id: 'period.hrs' })})
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                </p>
              ) : (
                ''
              )}
            </div>
          );
        }
        return '-';
      },
      sorter: (a, b) => a.flight_seconds_due - b.flight_seconds_due,
    };
    const cyclesColumn = {
      title: formatMessage({ id: 'title.cycles' }),
      dataIndex: 'cycles_repeat',
      rowKey: 'cycles_repeat',
      width: 150,
      render: (text, row) => {
        if (row.cycles_repeat || row.cycles_due) {
          return (
            <div className={styles.oopDetails}>
              {row.cycles_repeat ? (
                <p>
                  {formatMessage({ id: 'title.interval' })}:
                  <span className={styles.columnSpan}>
                    {row.cycles_repeat} {formatMessage({ id: 'units.cycles' })}
                    {row.cycles_threshold && row.cycles_threshold >= row.cycles_due ? (
                      <span className={styles.secondarySpan}>
                        {' '}
                        ({formatMessage({ id: 'text.thresholdShort' })} {Math.abs(row.cycles_threshold)}{' '}
                        {formatMessage({ id: 'units.cycles' })})
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                </p>
              ) : (
                ''
              )}
              {row.cycles_due ? (
                <p>
                  {formatMessage({ id: 'text.nextDue' })}:
                  <span className={styles.columnSpan}>
                    {row.cycles_due} {formatMessage({ id: 'period.cycles' })}
                    {row.cycles_tolerance ? (
                      <span className={styles.secondarySpan}>
                        {' '}
                        (+/- {Math.abs(row.cycles_tolerance)} {formatMessage({ id: 'period.cycles' })})
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                </p>
              ) : (
                ''
              )}
            </div>
          );
        }
        return '-';
      },
      sorter: (a, b) => a.cycles_due - b.cycles_due,
    };
    const monthsColumn = {
      title: formatMessage({ id: 'title.months' }),
      dataIndex: 'months_repeat',
      rowKey: 'months_repeat',
      width: 150,
      render: (text, row) => {
        if (row.months_repeat || row.date_due) {
          return (
            <div className={styles.oopDetails}>
              {row.months_repeat ? (
                <p>
                  {formatMessage({ id: 'title.interval' })}:
                  <span className={styles.columnSpan}>
                    {row.months_repeat} {formatMessage({ id: 'units.months' })}
                    {row.months_threshold &&
                    row.months_threshold >= Math.abs(moment(row.date_due).diff(moment(), 'months', true)) ? (
                      <span className={styles.secondarySpan}>
                        {' '}
                        ({formatMessage({ id: 'text.thresholdShort' })} {Math.abs(row.months_threshold)}{' '}
                        {formatMessage({ id: 'units.months' })})
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                </p>
              ) : (
                ''
              )}
              {row.date_due ? (
                <p>
                  {formatMessage({ id: 'text.nextDue' })}:
                  <span className={styles.columnSpan}>
                    {moment(row.date_due).format(dateFormat)}
                    {row.months_tolerance ? (
                      <span className={styles.secondarySpan}>
                        {' '}
                        (+/- {Math.abs(row.months_tolerance)} {formatMessage({ id: 'units.months' })})
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                </p>
              ) : (
                ''
              )}
            </div>
          );
        }
        return '-';
      },
      sorter: (a, b) => {
        if (!a.date_due) {
          return -1;
        }
        if (!b.date_due) {
          return 1;
        }
        return moment(a.date_due) - moment(b.date_due);
      },
    };
    const apuHrsColumn = {
      title: formatMessage({ id: 'title.apuHours' }),
      dataIndex: 'apu_seconds_repeat',
      rowKey: 'apu_seconds_repeat',
      width: 150,
      render: (text, row) => {
        if (row.apu_seconds_repeat || row.apu_seconds_due) {
          return (
            <div className={styles.oopDetails}>
              {row.apu_seconds_repeat ? (
                <p>
                  {formatMessage({ id: 'title.interval' })}:
                  <span className={styles.columnSpan}>
                    {Math.abs(row.apu_seconds_repeat / 3600)} {formatMessage({ id: 'period.hrs' })}
                    {row.apu_seconds_threshold && row.apu_seconds_threshold >= row.apu_seconds_due ? (
                      <span className={styles.secondarySpan}>
                        {' '}
                        ({formatMessage({ id: 'text.thresholdShort' })}
                        {Math.abs(row.apu_seconds_threshold / 3600)} {formatMessage({ id: 'period.hrs' })})
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                </p>
              ) : (
                ''
              )}
              {row.apu_seconds_due ? (
                <p>
                  {formatMessage({ id: 'text.nextDue' })}:
                  <span className={styles.columnSpan}>
                    {Math.abs(row.apu_seconds_due / 3600)} {formatMessage({ id: 'period.hrs' })}
                    {row.apu_seconds_tolerance ? (
                      <span className={styles.secondarySpan}>
                        {' '}
                        (+/- {Math.abs(row.apu_seconds_tolerance / 3600)} {formatMessage({ id: 'period.hrs' })})
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                </p>
              ) : (
                ''
              )}
            </div>
          );
        }
        return <div>-</div>;
      },
      sorter: (a, b) => a.apu_seconds_due - b.apu_seconds_due,
    };
    const estDueColumn = {
      title: formatMessage({ id: 'title.estimatedDue' }),
      dataIndex: 'estimated_date',
      rowKey: 'estimated_date',
      width: 200,
      render: (text, record) => {
        if (text) {
          return (
            <div className={styles.oopDetails}>
              <p>
                {formatMessage({ id: 'text.estimatedShort' })}:
                <span className={styles.columnSpan}>{moment(text).format(dateFormat)}</span>
              </p>
            </div>
          );
        }
        if (record.date_due) {
          return (
            <div className={styles.oopDetails}>
              {formatMessage({ id: 'text.due' })}:
              <p>
                <span className={styles.columnSpan}>{moment(record.date_due).format(dateFormat)}</span>
              </p>
            </div>
          );
        }
        return (
          <div>
            <p>-</p>
          </div>
        );
      },
      sorter: (a, b) => {
        if (!a.estimated_date) {
          return -1;
        }
        if (!b.estimated_date) {
          return 1;
        }
        return moment(a.estimated_date) - moment(b.estimated_date);
      },
    };
    const statusColumn = {
      title: formatMessage({ id: 'title.status' }),
      dataIndex: 'flight_seconds_remaining',
      width: 300,
      render: (text, row) => {
        return (
          <ProgressBars
            mxItem={row}
            hasAPU={aircraftAPUEnabled}
            aircraftThreshold={aircraftThreshold}
            data-test="progressBars"
          />
        );
      },
    };
    const columnsArray = [itemRefColumn, flightHrsColumn, cyclesColumn, monthsColumn, estDueColumn, statusColumn];
    if (selectedAircraft && selectedAircraft.apu_installed) {
      columnsArray.splice(4, 0, apuHrsColumn);
    }
    return columnsArray;
  }

  render() {
    const { dataSource, extraColumns, intl } = this.props;
    const newExtraColumns = extraColumns || [];
    return (
      <Table
        title={() => <div className={styles.tableTitle}>{intl.formatMessage({ id: 'title.outOfPhaseItems' })}</div>}
        columns={this.renderOopColumns().concat(newExtraColumns)}
        scroll={{ x: 1360 }}
        className={styles.defaultTable}
        pagination={{
          showSizeChanger: true,
          showQuickJumper: true,
        }}
        rowKey={(item) => item.id}
        dataSource={dataSource}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.props}
        locale={{
          emptyText: (
            <div className={styles.emptyText}>
              <img src={EmptyStateMaintenance} alt="empty state" />
              <span>No Data</span>
            </div>
          ),
        }}
      />
    );
  }
}

const oopTableWithRedux = connect(({ userSettings }) => ({
  userSettings,
}))(OopTable);
export default injectIntl(oopTableWithRedux);
